import { FC } from 'react';
import Icon from 'components/ui/icon';
import I18nHelpers from 'i18n/I18nHelpers';

interface Props {
  icon: string;
  title: string;
}

export const MainMenuItem: FC<Props> = ({ icon, title }) => (
  <>
    <Icon size={18} className='main-menu__item-icon' name={icon} />
    <div className='main-menu__item-text'>{I18nHelpers.getJsx(title)}</div>
  </>
);
